import styles from "./IncomeInfo.module.scss";
import currencyIcon from "../../../../icons/currency.png";
import currencySmallIcon from "../../../../icons/currency-small.png";
import { FC } from "react";
import { useSelector } from "../../../../hooks";
import { formatNumberWithSpaces } from "../../../../utils/numbers";
import { QuizStatus } from "../../../../redux/quizzes";

export const IncomeInfo: FC = () => {
    const { quiz, answerResult } = useSelector(store => store.quiz);

    if (!quiz)
        return <></>;

    const getQuestionComplexityText = () => {
        switch (quiz.question.complexity) {
            case 1: return 'легкий';
            case 2: return 'средний';
            case 3: return 'сложный';
        }
    }

    const isFinished = () => {
        return quiz.status === QuizStatus.Expired || quiz.status === QuizStatus.Finished || quiz.status === QuizStatus.WaitingFinishRequest;
    }

    const getTotalIncome = () => quiz.totalReward + Number(answerResult?.isRightAnswer ?? 0) * quiz.question.reward;

    const getReward = () => formatNumberWithSpaces(quiz.question.reward);

    const currencyImg = <img className={styles.currency} src={currencySmallIcon} alt="currencySmall" />;

    return (
        <>
            <div className={styles.incomeInfoBlock}>
                <div>
                    <span className={styles.incomeTitle}>Заработано</span>
                </div>
                
                <div className={styles.incomePriceBlock}>
                    <img src={currencyIcon} alt="currency" />
                    <span className={styles.incomePrice}>{ formatNumberWithSpaces(getTotalIncome()) }</span>
                </div>
            </div>

            <div className={styles.descriptionBlock}>
                { !isFinished() && <div>{ `Вопрос ${quiz.stageNumber} из ${quiz.totalQuestionsCount} (${getQuestionComplexityText()})` }</div> }
                { !answerResult && <div>{currencyImg}{`${ getReward() } за правильный ответ`}</div> }
            </div>
        </>
    );
};
